export default "__VITE_ASSET__ee115cac__"